module.exports = __webpack_public_path__ + "static/mini_calendar_example_template-b003937d78078f23ec3060227bdfca87.png";